var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 3.83337L8.47079 8.59624C9.02176 8.98193 9.29725 9.17477 9.59691 9.24946C9.8616 9.31544 10.1384 9.31544 10.4031 9.24946C10.7028 9.17477 10.9783 8.98193 11.5293 8.59624L18.3334 3.83337M5.66669 14.6667H14.3334C15.7335 14.6667 16.4336 14.6667 16.9683 14.3942C17.4387 14.1545 17.8212 13.7721 18.0609 13.3017C18.3334 12.7669 18.3334 12.0668 18.3334 10.6667V5.33337C18.3334 3.93324 18.3334 3.23318 18.0609 2.6984C17.8212 2.22799 17.4387 1.84554 16.9683 1.60586C16.4336 1.33337 15.7335 1.33337 14.3334 1.33337H5.66669C4.26656 1.33337 3.56649 1.33337 3.03171 1.60586C2.56131 1.84554 2.17885 2.22799 1.93917 2.6984C1.66669 3.23318 1.66669 3.93324 1.66669 5.33337V10.6667C1.66669 12.0668 1.66669 12.7669 1.93917 13.3017C2.17885 13.7721 2.56131 14.1545 3.03171 14.3942C3.56649 14.6667 4.26656 14.6667 5.66669 14.6667Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.43b0d3166902f354702a4df67729bbaf.svg";
export { ForwardRef as ReactComponent };